var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    background:
      _vm.extras['custom' + _vm.index + 'Bg'] &&
      _vm.extras['custom' + _vm.index + 'Bg'].colorOrBg == 'color'
        ? _vm.extras['custom' + _vm.index + 'Bg'].color
        : _vm.extras['custom' + _vm.index + 'Bg'] &&
          _vm.extras['custom' + _vm.index + 'Bg'].src
        ? 'url(' + _vm.extras['custom' + _vm.index + 'Bg'].src + ')'
        : '',
    'background-size': 'cover',
  })},[(_vm.extras['custom' + _vm.index + 'Display' + _vm.type].display == 1)?_c('div',{staticClass:"custom-img top-nav",class:_vm.type},[_c('a',{style:({
        cursor:
          _vm.extras['custom' + _vm.index + 'ImgUrl' + _vm.type].model.replace(
            'https://',
            ''
          ).length > 0
            ? 'pointer'
            : 'default',
      }),attrs:{"target":_vm.extras['custom' + _vm.index + 'ImgUrl' + _vm.type].model.replace(
          'https://',
          ''
        ).length > 0
          ? '_blank'
          : '',"href":_vm.extras['custom' + _vm.index + 'ImgUrl' + _vm.type].model.replace(
          'https://',
          ''
        ).length > 0
          ? _vm.extras['custom' + _vm.index + 'ImgUrl' + _vm.type].model
          : 'javascript:void(0)'}},[_c('img',{attrs:{"src":_vm.extras['custom' + _vm.index + 'Img' + _vm.type].src,"alt":""}})])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }